module.exports = __webpack_public_path__ + "img/demo1.5cc475fc.jpg";